import { useContext } from "react";

import { css } from "@emotion/react";

import { LanguageIcon } from "@dotnet/telematics-design-system";

import { useMenu } from "components/Actions/ActionBar/hooks";
import Button, {
    BUTTON_COLORS,
    BUTTON_SIZES,
    BUTTON_VARIANTS
} from "components/DesignComponents/Button";
import Menu, {
    centeredAnchorOrigin,
    centeredTransformOrigin
} from "components/DesignComponents/Menu";
import AuthContext from "context/auth/authContext";
import ListOfLanguages from "context/language/components/ListOfLanguages";
import LanguageContext from "context/language/languageContext";

const LanguageSelection = () => {
    const { languages, language } = useContext(LanguageContext);
    const { user } = useContext(AuthContext);

    const { anchorEl, handleCloseMenu, handleOpenMenu } = useMenu();

    return (
        <>
            <Button
                color={BUTTON_COLORS.White}
                size={BUTTON_SIZES.Small}
                variant={BUTTON_VARIANTS.IconLeft}
                icon={<LanguageIcon />}
                onClick={handleOpenMenu}
                containerStyles={{
                    minWidth: "0"
                }}
                css={css({
                    overflowX: "hidden"
                })}
            >
                <span
                    css={css({
                        minWidth: "0",
                        overflowX: "hidden",
                        textOverflow: "ellipsis"
                    })}
                >
                    {languages.find(({ id }) => id === language)?.label}
                </span>
            </Button>

            <Menu
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorEl={anchorEl}
                anchorOrigin={centeredAnchorOrigin}
                transformOrigin={centeredTransformOrigin}
                slotProps={{
                    list: {
                        disableListWrap: true
                    }
                }}
                css={css({
                    "& .MuiMenu-paper": {
                        maxHeight: "432px",
                        maxWidth: "216px"
                    }
                })}
            >
                <ListOfLanguages hasApiCall={user !== null} />
            </Menu>
        </>
    );
};

export default LanguageSelection;
